import { render, staticRenderFns } from "./DialogChangePwd.vue?vue&type=template&id=5a5ebe85&scoped=true&"
import script from "./DialogChangePwd.vue?vue&type=script&lang=js&"
export * from "./DialogChangePwd.vue?vue&type=script&lang=js&"
import style0 from "./DialogChangePwd.vue?vue&type=style&index=0&id=5a5ebe85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5ebe85",
  null
  
)

export default component.exports